import Swiper from 'swiper/swiper-bundle'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import item from 'isotope-layout/js/item'
const filterTabs = document.querySelectorAll('.filterTab')

console.log('about')
function arrangeLayout() {
  // const projects = document.querySelectorAll('.project')
  //   projects.forEach(project => {
  //     const projectDisplay = window.getComputedStyle(project).display
  //     if(projectDisplay === 'flex'){
  //       // console.log(project)
  //     }
  //   });
}

// Arrange layout using filters with isotope JS
function tabFilter() {
  // Isotope JS to filter elements
  const elem = document.querySelector('.projects__list')
  const elem2 = document.querySelector('.projects__list-container')
  const projects = document.querySelectorAll('.project')

  // Two instanciation to filter in both project displays container
  const iso = new Isotope(elem, {
    // options
    itemSelector: '.project',
    layoutMode: 'vertical'
  })
  const iso2 = new Isotope(elem2, {
    // options
    itemSelector: '.project',
    layoutMode: 'vertical'
  })

  const filterButtons = document.querySelectorAll('.projects__nav-item')
  filterButtons.forEach((filterButton) => {
    filterButton.addEventListener('click', () => {
      const dataFilter = filterButton.getAttribute('data-filter')
      const filter = dataFilter ? `.${dataFilter}` : null
      for (let i = 0; i < filterButtons.length; i++) {
        filterButtons[i].classList.remove('active')
      }

      const active = []

      for (let i = 0; i < projects.length; i++) {
        if (filter) {
          if (projects[i].classList.contains(dataFilter)) {
            projects[i].classList.add('active')
            active.push(projects[i])
          } else {
            projects[i].classList.remove('active')
          }
        } else {
          projects[i].classList.add('active')
          active.push(projects[i])
        }

        projects[i].classList.remove('odd', 'even')
      }

      for (let i = 0; i < active.length; i++) {
        if (i % 2 === 0) {
          active[i].classList.add('odd')
        } else {
          active[i].classList.add('even')
        }
      }

      filterButton.classList.add('active')

      iso.arrange({
        // item element provided as argument
        filter
      })

      iso2.arrange({
        // item element provided as argument
        filter
      })
      
      arrangeLayout()
    })
  })
}
imagesLoaded(document.querySelector('.projects__list'), function (instance) {
  tabFilter()
})

// Remove activ from all tabs
function removeActivTabs() {
  for (const tabs of filterTabs) {
    tabs.classList.remove('activ')
  }
}

// Remove activ from all tabs and add on the appropriate one
function cleanTabs() {
  filterTabs.forEach((filterTab) => {
    filterTab.addEventListener('click', () => {
      removeActivTabs()
      filterTab.classList.add('activ')
    })
  })
}

/// Responsive Filters

const buttonLabel = document.querySelector('.projects_responsive-button-label')
const projectItems = document.querySelectorAll('.projects__nav-item-mobile')

const allProjectLabel = document.querySelector('.projects__filter-item')
const dropdownCheckbox = document.querySelector('.projects_responsive-input')

function displayItems() {
  for (const item of projectItems) {
    item.style.display = 'block'
  }
}

if (projectItems) {
  projectItems.forEach((item) => {
    item.addEventListener('click', () => {
      buttonLabel.innerHTML = item.textContent
      buttonLabel.classList.remove('active')
      displayItems()
      item.style.display = 'none'
    })
  })
}

if (buttonLabel) {
  buttonLabel.addEventListener('click', () => {
    if (dropdownCheckbox.checked) {
      buttonLabel.classList.remove('active')
    } else {
      buttonLabel.classList.add('active')
    }
  })
}
if (allProjectLabel) {
  allProjectLabel.style.display = 'none'
}

export default {
  init() {
    // JavaScript to be fired on the about us page

    // Team slider
    const sliderTeam = new Swiper('.teamSlider .swiperTeam', {
      slidesPerView: 'auto',
      spaceBetween: 30,
      grabCursor: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
       dragSize : 50
      }
    })

    cleanTabs()

    const displayProjectsCtaContainer = document.querySelector('.projects__list-display-cta')
    const displayProjectsCta = document.querySelector('.projects__list-display-cta span')

    const allProjectsCta = document.querySelectorAll('.projects__nav-all-projects-cta')
    const moreProjectsContainer = document.querySelector('.projects__list-hidden')

    let displayProjects = false

    displayProjectsCtaContainer.addEventListener('click', () => {
      if (!allProjects) {
        displayProjectsCtaContainer.style.display = 'none'
      }
      displayProjectsCtaContainer.classList.toggle('clicked')
      moreProjectsContainer.classList.toggle('active')
      displayProjects = !displayProjects

      displayProjects
        ? (displayProjectsCta.textContent = 'Less projects')
        : (displayProjectsCta.textContent = 'More projects')
    })

    const filtersCta = document.querySelectorAll('.projects__nav div:not(.projects__nav-all-projects-cta)')
    let allProjects = true

    filtersCta.forEach((cta) => {
      cta.addEventListener('click', () => {
        allProjects = false
        if (!allProjects) {
          moreProjectsContainer.classList.add('active')
          displayProjectsCtaContainer.style.display = 'none'
        }
      })
    })

    allProjectsCta.forEach((cta) => {
      cta.addEventListener('click', () => {
        allProjects = true
        displayProjectsCtaContainer.style.display = 'flex'
        // displayProjectsCtaContainer.classList.toggle('clicked')
        if (displayProjects === false) {
          moreProjectsContainer.classList.remove('active')
        }
      })
    })
  },
  finalize() {
    // JavaScript to be fired on the about us page, after the init JS
  }
}
